import { isEmpty, concat } from 'lodash';
import axios from 'axios';
import api from '@/helpers/api';

/**
 * Method sorts permissions by name.
 * This is needed later for the permissions settings to show the permission correctly from the model on the inputs because if the order of the elements is not correct then vue model cannot match it.
 * @param {*} permissions Object containing permission key value pairs.
 */
function sortPermissionsByName(permissions) {
  Object.values(permissions).forEach(permissionValue => permissionValue.sort());
  return permissions;
}

const actions = {
  fetchMerchants({ commit }) {
    commit('START_LOADING_MERCHANT_LIST');
    api('GET', 'merchants/data')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_MERCHANTS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  // deprecated
  fetchMerchant({ commit }, merchantId) {
    commit('START_LOADING_MERCHANT', true);
    api('GET', `merchants/${merchantId}/data`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_MERCHANT', response.data); // TODO fix this
          commit('SET_MERCHANT_PARTIAL_DATA', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchOrganisationMerchants({ commit }, merchantIDs) {
    merchantIDs.forEach((merchantID) => {
      commit('START_LOADING_MERCHANT', true);
      api('GET', `merchants/${merchantID}/data`)
        .then((response) => {
          if (response.status === 200) {
            commit('SET_MERCHANT', response.data);
          }
        })
        .catch((error) => {
          commit('API_ERROR', error.response);
        });
    });
  },
  fetchSettings({ commit }, merchantId) {
    api('GET', `/merchants/${merchantId}/settings`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_SETTINGS', response.data);
          response.data.merchantId = merchantId;
          commit('MERCHANT_AVAILABILITY', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  // DEPRECATED
  fetchAvailabilities({ commit }, merchantId) {
    api('GET', `/merchants/${merchantId}/availabilities`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_AVAILABILITIES', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchWorkingHours({ commit }, payload) {
    return api('GET', `organisation/${payload.organisationId}/business/${payload.businessId}/working-hours`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_AVAILABILITIES', response.data);
        }
        return response;
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  setMerchantPartialData({ commit }, payload) {
    commit('SET_MERCHANT_PARTIAL_DATA', payload);
  },
  updateMerchant({ commit, dispatch }, payload) {
    commit('SET_MERCHANT_UPDATED', false);
    api('PUT', `merchants/${payload.merchant_id}`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_MERCHANT_UPDATED', payload.merchant_id);
          dispatch('fetchMerchant', payload.merchant_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateLogo({ commit }, payload) {
    api('POST', `merchants/${payload.merchant_id}/logo`, payload.data, {
      'Content-Type': 'multipart/form-data',
    })
      .then((response) => {
        if (response.status === 200) {
          commit('SET_LOGO', {
            merchant_id: payload.merchant_id,
            logo: response.data.logo,
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updatePlan({ commit }, payload) {
    api('PUT', `merchants/${payload.merchant_id}/plan`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('PLAN_SUBSCRIPTION_UPDATED', {
            merchant_id: payload.merchant_id,
          });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateAvailability({ commit }, payload) {
    commit('AVAILABILITY_UPDATED', false);
    api('PUT', `/merchants/${payload.merchant_id}/availability`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('AVAILABILITY_UPDATED', true);
          payload.available = payload.data.available;
          payload.merchantId = payload.merchant_id;
          commit('MERCHANT_AVAILABILITY', payload);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  // DEPRECATED
  updateAvailabilityTimes({ commit }, payload) {
    commit('AVAILABILITY_TIMES_UPDATED', false);
    api('PUT', `/merchants/${payload.merchant_id}/availability-times`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('AVAILABILITY_TIMES_UPDATED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateAvailabilityTimes20({ commit }, payload) {
    commit('AVAILABILITY_TIMES_UPDATED', false);
    const request = api('PUT', `organisation/${payload.organisationId}/business/${payload.businessId}/working-hours`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('AVAILABILITY_TIMES_UPDATED', true);
          commit(
            'organisation/UPDATE_BUSINESS_TIMEZONE',
            {
              businessId: payload.businessId,
              timezone: payload.data.timezone,
            },
            { root: true },
          );
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });

    return request;
  },
  // fetchFacebookRecipients({ commit }, merchantId) {
  //   api('GET', `merchants/${merchantId}/social-platforms/facebook/recipients`, { limit: 5 })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         commit('SET_FB_RECIPIENTS', response.data);
  //       }
  //     })
  //     .catch((error) => {
  //       commit('API_ERROR', error.response);
  //     });
  // },
  // searchFacebookRecipients({ commit }, payload) {
  //   api('GET', `merchants/${payload.merchant_id}/social-platforms/facebook/recipients/search`, { name: payload.name })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         commit('FOUND_FB_RECIPIENTS', response.data);
  //       }
  //     })
  //     .catch((error) => {
  //       commit('API_ERROR', error.response);
  //     });
  // },

  fetchAnalytics({ commit }, payload) {
    api('GET', `merchants/${payload.merchant_id}/analytics`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_ANALYTICS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchSubscriptions({ commit }) {
    commit('SUBSCRIPTIONS_RELOADED', false);
    api('GET', 'merchants/subscriptions')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_SUBSCRIPTIONS', response.data);
          commit('SUBSCRIPTIONS_RELOADED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchPermissionRoles({ commit, rootState }) {
    commit('PERMISSION_ROLES_LOADED', false);
    const endpoint = `organisation/${rootState.organisation.currentOrganisation.id}/permissions`;
    api('GET', endpoint, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          const sortedPermissions = sortPermissionsByName(response.data);
          commit('SET_PERMISSION_ROLES', sortedPermissions);
          // commit('SET_PERMISSIONS_IN_STORAGE', {
          //   merchant_id: merchantId,
          //   data: sortedPermissions,
          // });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateNumberName({ commit, rootState }, payload) {
    const endpoint = `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.numberId}/data`;
    const request = api('PUT', endpoint, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit(
            'organisation/UPDATE_NUMBER_NAME',
            {
              name: payload.data.name,
              emoji: payload.data.emoji,
              uid: payload.numberId[0],
            },
            { root: true },
          );
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  fetchAppKey({ commit, rootState }, merchantId) {
    commit('APP_KEY_LOADED', false);
    const endpoint = `/organisation/${rootState.organisation.currentOrganisation.id}/business/${merchantId}/api-key`;
    api('GET', endpoint, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_APP_KEY', response.data);
          commit('APP_KEY_LOADED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateAppKey({ commit, rootState }, merchantId) {
    commit('APP_KEY_UPDATED', false);
    const endpoint = `/organisation/${rootState.organisation.currentOrganisation.id}/business/${merchantId}/api-key`;
    api('PUT', endpoint, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('APP_KEY_UPDATED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updatePermissions({ commit, rootState }, payload) {
    commit('PERMISSION_ROLES_UPDATED', false);
    const endpoint = `organisation/${rootState.organisation.currentOrganisation.id}/permissions`;
    api('PUT', endpoint, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('PERMISSION_ROLES_UPDATED', true);
          // commit('SET_PERMISSIONS_IN_STORAGE', {
          //   merchant_id: payload.merchant_id,
          //   data: payload.data.permissions,
          // });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  /** If no id is passed then fetch for organisation otherwise for specific business */
  fetchMembersWithInvitations({ commit, rootState }, payload) {
    if (payload && !payload.skipVuex && !payload.silentReload) {
      commit('LOADING_MEMBERS', true);
    }
    let fetchPerBusiness = '';
    if (payload && payload.businessId) {
      fetchPerBusiness = `business/${payload.businessId}/`;
    }
    const data = payload ? payload.data : {};
    data.limit = 100;
    return axios.all([
      payload && payload.skipInvitations ? null : api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/${fetchPerBusiness}invitations`, data, null, 'w'),
      api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/${fetchPerBusiness}users`, data, null, 'w'),
    ])
      .then(axios.spread((invitationData, userData) => {
        const invitations = invitationData ? invitationData.data.invitations : [];
        let users = userData.data.data;
        if (payload && payload.append) {
          users = payload.data.page && payload.data.page > 1 ? [...rootState.merchant.membersAndInvitations, ...users] : [...users];
        }
        if (!payload || !payload.skipVuex) {
          commit('SET_MERCHANT_MEMBERS_INVITATIONS', [...invitations, ...users]);
          commit('SET_MEMBERS_META', userData.data.meta);
        }
        return [...invitations, ...users];
      }))
      .catch((error) => {
        commit('API_ERROR', error.response);
      })
      .finally(() => {
        commit('LOADING_MEMBERS', false);
      });
  },
  /**
   * Method will fetch all the members for the organisation.
   *
   * NOTE - Limit on the backend is set to be max 100 so if you have more than a 100 members you will have to load more pages manually.
   *
   * @param {*} VUEX options
   * @param page Page on the members endpoint.
   * @returns api response as a promise
   */
  fetchAllMembers({ rootState }, page = 1) {
    let data = {
      limit: 100,
    };
    data = { ...data, page };
    return api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/users`, data, null, 'w');
  },
  fetchMembers({ commit }, merchantId) {
    commit('LOADING_MEMBERS', true);
    api('GET', `merchants/${merchantId}/users`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_MERCHANT_MEMBERS', response.data);
        }
      })
      .catch((error) => {
        commit('LOADING_MEMBERS', false);
        commit('API_ERROR', error.response);
      });
  },
  bulkMembersToNumber({ commit, rootState }, payload) {
    const request = api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/users`, payload, null, 'w');
    request
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  // Obsolete
  inviteMember({ commit }, payload) {
    api('POST', `merchants/${payload.merchant_id}/invitations`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('MEMBER_INVITED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  inviteMembers({ commit, rootState }, payload) {
    return api('POST', `organisation/${rootState.organisation.currentOrganisation.id}/invitations`, payload.data, null, 'w')
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  reInviteMember({ rootState }, payload) {
    return api('POST', `organisation/${rootState.organisation.currentOrganisation.id}/invitations/${payload.inivitationId}/resend`, null, null, 'w');
  },
  // obsolete ?
  changeMemberRole({ commit }, payload) {
    api('PUT', `merchants/${payload.merchant_id}/users/${payload.member_id}/role`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('MEMBER_ROLE_CHANGED', payload.member_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  // Obsolete
  changeMemberTeam({ commit }, payload) {
    api('PUT', `merchants/${payload.merchant_id}/users/${payload.member_id}/teams`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('MEMBER_TEAMS_CHANGED', payload.member_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  editMember({ rootState }, payload) {
    return api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/users/${payload.memberId}`, payload.data, null, 'w');
  },
  transferOwnership({ rootState }, payload) {
    const request = api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/transfer-ownership`, payload, null, 'w');
    return request;
  },
  deleteInvitation({ rootState }, payload) {
    // return api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/invitations/${payload.businessId}`, null, null, 'w');
    return api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/invitations/${payload.invitationId}`, payload.data, null, 'w');
    // api('DELETE', `merchants/${payload.merchant_id}/invitations/${payload.invitation_id}`)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       commit('INVITATION_DELETED', payload.invitation_id);
    //     }
    //   })
    //   .catch((error) => {
    //     commit('API_ERROR', error.response);
    //   });
  },
  deleteMember({ rootState }, payload) {
    return api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/users/${payload.memberId}`, payload.data, null, 'w');
    // api('DELETE', `merchants/${payload.merchant_id}/users/${payload.member_id}`)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       commit('MEMBER_DELETED', payload.member_id);
    //     }
    //   })
    //   .catch((error) => {
    //     commit('API_ERROR', error.response);
    //   });
  },

  // connectStripe({ commit }, payload) {
  //   api('POST', `merchants/${payload.merchant_id}/payment-providers/stripe`, payload.data)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         commit('STRIPE_CONNECTED', response.data);
  //       }
  //     })
  //     .catch((error) => {
  //       commit('API_ERROR', error.response);
  //     });
  // },
  // disconnectStripe({ commit }, merchantId) {
  //   api('DELETE', `merchants/${merchantId}/payment-providers/stripe`)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         commit('STRIPE_DISCONNECTED', response.data);
  //       }
  //     })
  //     .catch((error) => {
  //       commit('API_ERROR', error.response);
  //     });
  // },

  memberRemovedFromOrganisation({ commit }, payload) {
    commit('REMOVE_MEMBER_FROM_ORGANISATION', payload);
  },
  addMemberToBusiness({ commit, rootState, dispatch }, payload) {
    // const targetBusiness = rootState.organisation.currentOrganisation.businesses.find(business => business.id === payload.business_uid);

    // const targetMember = rootState.organisationMembersLookup[payload.user_uid];

    // commit('ADD_MEMBER_TO_BUSINESS', { ...payload, businessToAdd: { name: targetBusiness.name, uid: targetBusiness.id } });

    // dispatch('organisation/')
  },
  removeMemberFormBusiness({ commit }, payload) {
    // commit('REMOVE_MEMBER_FROM_BUSINESS', payload);
  },
  fetchBlockedContacts({ commit, rootState }, payload) {
    commit('FETCHING_BLOCKED', true);
    api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/contacts?business=${payload.businessId}&blocked=true`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          const newContacts = response.data.data;
          if (payload.append) {
            response.data.data = payload.data.page && payload.data.page > 1 ? [...rootState.merchant.blocklist.data, ...newContacts] : [...newContacts];
          }
          commit('SET_BLOCKED_CONTACTS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      })
      .finally(() => {
        commit('FETCHING_BLOCKED', false);
      });
  },
};

export default actions;
